/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    IAccountPreference,
    IAccountPreferences,
    IAccountProfileItem,
    IAccountProfileViewProps
} from '@msdyn365-commerce-modules/account-management/src/modules/account-profile/./account-profile';
import { IAccountProfileProps } from '../definition-extensions/account-profile.ext.props.autogenerated';
import { kRV_GetAddressAsync } from '../../../actions/customProxy/MyAccount/DataActionExtension.g';
import { IAccountProfileData } from './account-profile.data';

const AccountPreferencesSection: React.FC<IAccountPreferences> = ({ accountPreferences, heading, personalization, extraPreferences }) => {
    return (
        <Node {...accountPreferences}>
            {heading}
            <AccountPreferenceSection {...personalization} />
            {extraPreferences &&
                extraPreferences.map((preferenceSecton, index) => {
                    return <AccountPreferenceSection {...preferenceSecton} key={index} />;
                })}
        </Node>
    );
};

const AccountPreferenceSection: React.FC<IAccountPreference> = ({
    accountPreference,
    heading,
    description,
    buttonWrapper,
    buttonYesText,
    button,
    buttonNoText
}) => {
    return (
        <Node {...accountPreference}>
            {heading}
            {description}
            <Node {...buttonWrapper}>
                {buttonNoText}
                {button}
                {buttonYesText}
            </Node>
        </Node>
    );
};

const AccountProfileSection: React.FC<IAccountProfileItem> = ({ AccountProfileItem, heading, links, description }) => {
    return (
        <Node {...AccountProfileItem}>
            {heading}
            {description}
            {links}
        </Node>
    );
};

const AccountProfileView: React.FC<IAccountProfileViewProps & IAccountProfileProps<IAccountProfileData>> = props => {
    const {
        AccountProfile,
        accountProfileWrapper,
        heading,
        emailSection,
        preferenceSection,
        customerAttributesWrapper,
        customerAttributesSection,
        data: { accountInformation, customerInformation }
    } = props;

    const [billingAddress, setBillingAddress] = React.useState<any>();
    const companyName = customerInformation.result?.ExtensionProperties?.find(item => item.Key === 'CompanyName');
    const context1 = { callerContext: props.context.actionContext };
    const accountNumber = accountInformation?.result?.AccountNumber;
    const invoiceAccountNumber = accountInformation.result?.InvoiceAccount;
    let billAddress: string | undefined;
    let billName: string | undefined;
    let billNumber: string | undefined;

    if (invoiceAccountNumber === '') {
        accountInformation.result?.Addresses?.map((item: any) => {
            if (item.IsPrimary === true) {
                billName = item.Name;
                billAddress = item.FullAddress;
                billNumber = item.Phone;
            }
        });
    } else {
        billName = accountInformation.result?.Name;
        billAddress = billingAddress?.FullAddress!;
        billNumber = accountInformation.result?.Phone;
    }
    React.useEffect(() => {
        if (accountNumber) {
            kRV_GetAddressAsync(context1, accountNumber).then((result: any) => {
                setBillingAddress(result[0]);
            });
        }
    }, [accountNumber]);
    return (
        <Module {...AccountProfile}>
            {/* {infoMessageBar} */}
            {accountProfileWrapper && (
                <>
                    <Node {...accountProfileWrapper}>
                        {heading}
                        {/* VSI CUSTOMIZATION START */}
                        {/* <AccountProfileSection {...emailSection} />
                    <AccountProfileSection {...nameSection} /> */}
                        <div className='preference-section-container'>
                            <AccountPreferencesSection {...preferenceSection} />
                        </div>
                        <div className='my-profile-heading'>
                            {/* {props.resources.personalDataHeading} */}
                            <div className='first-name-container'>
                                {/* <AccountProfileSection {...nameSection} /> */}
                                <span className='first-name-label'>{props.resources.firstNameHeading}</span>
                                <span className='first-name-value'>{props.data.customerInformation.result?.FirstName}</span>
                            </div>
                            <div className='last-name-container'>
                                <span className='last-name-label'>{props.resources.lastNameHeading}</span>
                                <span className='last-name-value'>{props.data.customerInformation.result?.LastName}</span>
                            </div>
                            <div className='email-section-container'>
                                <AccountProfileSection {...emailSection} />
                            </div>
                            <div className='last-name-container'>
                                <span className='last-name-label'>{props.resources.companyNameHeading}</span>
                                <span className='last-name-value'>
                                    {companyName?.Value?.StringValue ? companyName?.Value?.StringValue : '-'}
                                </span>
                            </div>
                        </div>

                        {/* VSI CUSTOMIZATION End */}
                    </Node>
                    {billName && billNumber && (
                        <div className='my-profile-heading'>
                            <h2 className='address-heading'>{props.resources.billingAddressHeading}</h2>
                            <div className='first-name-container'>
                                <span className='first-name-label'>{props.resources.name}</span>
                                <span className='first-name-value'>{billName}</span>
                            </div>
                            <div className='last-name-container'>
                                <span className='last-name-label'>{props.resources.phone}</span>
                                <span className='last-name-value'>{billNumber}</span>
                            </div>
                            <div className='last-name-container'>
                                <span className='last-name-label'>{props.resources.fulladdress}</span>
                                <span className='last-name-value'>{billAddress ? billAddress : props.resources.noAddressFoundtext}</span>
                            </div>
                        </div>
                    )}
                </>
            )}
            {customerAttributesWrapper && <Node {...customerAttributesWrapper}>{customerAttributesSection}</Node>}
        </Module>
    );
};

export default AccountProfileView;
